<template>
  <div class="file-processor">
    <span class="xl-loading__icon" v-if="isLoading" />
    <ViewerPic
      :id="fileId" @close="close"
      :preview-file-info="previewFileInfo"
    />
  </div>
</template>

<script>

import { defineComponent } from 'vue'
import ViewerPic from './TheViewerPic'

export default defineComponent({
  components: {
    ViewerPic,
  },
  props: {
    previewFileInfo: {
      require: true,
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  setup (props) {
    return { ...props }
  },
  data: () => ({
    isLoading: true,
    showNoSupport: false,
    isShowImgComp: false,
    isShowVideoComp: false,
    isShowIframe: false,
    isBt: false,
    iframeSrc: '',
  }),
  computed: {
    fileId () {
      return this.previewFileInfo?.md5sum || ''
    },

    resource () {
      return this.previewFileInfo || {}
    },
  },
  async mounted () {
    this.isShowImgComp = true
    this.isLoading = false
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onFail () {
      this.isShowIframe = false
      this.showNoSupport = true
    },
  },
})
</script>
<style lang="scss">
.is-in-pc .file-processor {
  .dialog-viewer-picture>header {
    padding-top: 30PX;
  }

  .dialog-viewer-picture>header::after {
    content: "远程设备";
    color: black;
    width: 100%;
    display: flex;
    font-size: 14px;
    height: 30PX;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    background-color: white;
  }
}
</style>